/** Fixed BudgetCategoryCode enum (M-30 AD-PLN-BE-007). Shared by Budget + Expense UI. */
export const BUDGET_CATEGORY_CODES = Object.freeze([
  'ACCOMMODATION',
  'TRANSPORT',
  'FOOD',
  'TICKET',
  'SHOPPING',
  'INSURANCE',
  'COMMUNICATION',
  'OTHER',
]);

const BUDGET_CATEGORY_LABEL_KEYS = Object.freeze(Object.fromEntries(
  BUDGET_CATEGORY_CODES.map((code) => [code, `travel.journeyCost.categories.${code}`]),
));

/** 類別代碼 → 文案 key；未知代碼回空字串（不得映射為 OTHER）。 */
export function budgetCategoryLabelKey(code) {
  return BUDGET_CATEGORY_LABEL_KEYS[String(code || '')] || '';
}

/**
 * 類別顯示名稱只在呈現層翻譯；代碼本身仍是 API／DB 的識別值。
 * 未知或缺翻譯時顯示原始代碼，空值顯示 '—'，不得把文案 key 顯示給使用者。
 */
export function budgetCategoryLabel(code, t) {
  const raw = String(code || '');
  if (!raw) return '—';
  const key = budgetCategoryLabelKey(raw);
  if (!key || typeof t !== 'function') return raw;
  const label = t(key);
  return typeof label === 'string' && label && label !== key ? label : raw;
}
